module.exports = __webpack_public_path__ + "img/0Q3A9771_L_Foamcore_MockedUp.51374ebb.jpg";